import { useEffect } from 'react';
import { useFormikContext } from 'formik';

export const useCompanyOrPersonFilter = ({ personTypes, companyTypes }) => {
  const { values, setFieldValue } = useFormikContext();

  const enableCompanies = values['tipoCadastro'] !== 1;
  const enablePerson = values['tipoCadastro'] !== 2;

  useEffect(() => {
    if (!personTypes.length || !companyTypes.length) return;
    setFieldValue('tiposEmpresa', []);
    setFieldValue('tiposPessoaFisica', []);
  }, [companyTypes, personTypes, setFieldValue, values.tipoCadastro]);

  return {
    enableCompanies,
    enablePerson
  }
};
